// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1FTbY","productName":"Table_productName__3Meab"};